<svg width="89" height="88" viewBox="0 0 89 88" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" width="88" height="88" rx="44" fill="#34787A" fill-opacity="0.05" />
  <rect x="8.5" y="8" width="72" height="72" rx="36" fill="#34787A" fill-opacity="0.05" />
  <path d="M63.1663 31.167L37.4997 56.8337L25.833 45.167" stroke="#34787A" stroke-width="5.83333" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>